export default "__VITE_ASSET__BGHX$PmX__"